import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { API } from "../constants";
import useAuthStore from "../hooks/useAuthStore";

const Topbar = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [profileImage, setProfileImage] = useState("assets/images/user.jpeg");

  const navigate = useNavigate();

  const { user, clearUser } = useAuthStore();

  const defaultImage = "assets/images/user.jpeg";

  const isLoggedIn = !!user;

  const getProfileImageUrl = (profileImage) => {
    if (!profileImage) {
      return defaultImage;
    }

    if (profileImage.startsWith("http")) {
      return profileImage;
    }

    return `${API.IMAGE_URL}uploads/customers/${profileImage}`;
  };

  useEffect(() => {
    setProfileImage(getProfileImageUrl(user?.profileImage || user?.filePath));
  }, [user]);

  const handleLogout = async () => {
    try {
      await fetch(API.CUSTOMER_LOGOUT, {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      clearUser();

      navigate("/login");
    }
  };

  return (
    <>
      <div className="topbar">
        <div className="container">
          <div className="topbar-inner">
            <div className="social1 ms-auto d-flex align-items-center gap-2 me-4">
              <a
                href="https://www.facebook.com/"
                title="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>

              <a
                href="https://x.com/"
                title="Twitter"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-x-twitter"></i>
              </a>

              <a
                href="https://www.instagram.com/"
                title="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>

            <div className="topbar-register">
              {isLoggedIn ? (
                <Dropdown>
                  <Dropdown.Toggle className="login-btn" id="dropdown-basic">
                    <img
                      src={profileImage}
                      alt="User"
                      className="login-user-img"
                      onError={() => setProfileImage(defaultImage)}
                    />

                    {user?.firstName}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="login-dropdown">
                    <Dropdown.Item as={Link} to="/dashboard">
                      Dashboard
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => setShowLogoutModal(true)}>
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <>
                  <Link className="log-popup-btn" to="/login" title="Login">
                    LOGIN
                  </Link>

                  {" / "}

                  <Link
                    className="sign-popup-btn"
                    to="/register"
                    title="Register"
                  >
                    REGISTER
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
      >
        <Modal.Body className="text-center">
          <i className="fa-solid fa-right-from-bracket fa-3x mb-3"></i>

          <h5>Are you sure you want to logout?</h5>

          <div className="d-flex justify-content-center gap-3 mt-3">
            <Button
              variant="secondary"
              onClick={() => setShowLogoutModal(false)}
            >
              No
            </Button>

            <Button
              variant="danger"
              onClick={() => {
                setShowLogoutModal(false);

                handleLogout();
              }}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Topbar;
